import React, { useCallback, useContext, useEffect, useState } from 'react';
import { useHistory, Link } from 'react-router-dom';

import PbxContext from '../../../context/PbxContext';

import { accessLocalStorage, exportCreateEndpoints, valuesAnalyze, changeViewForms, readAllTenant, exportSelectAllMohs } from '../../../services';

import Loading from '../../../components/Loading/LoadingModule';
import './EndpointsForm.css';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPhoneSquare, faSave, faTimes } from '@fortawesome/free-solid-svg-icons';

function EndpointsCreate() {
  const getItensStateGlobal = useContext(PbxContext);
  const { majoritaryItemsEndpoints, toggleIsHidden, toggleIsChangeFormElements } = getItensStateGlobal;

  let url = window.location.href;
  url = url.split('/')[2];

  const history = useHistory();

  const [loading, setLoading] = useState(true);
  const [values, setValues] = useState({});
  const [validate, setValidate] = useState({});
  const [disable, setDisable] = useState(true);
  const [tenants, setTenants] = useState([]);
  const [mohs, setMohs] = useState([]);

  const { changeBorderImputToRedOrNormal, changeVisibityMessages} = changeViewForms;

  const fetchMohs = async (idtenant) => {
    try {
      const response = await exportSelectAllMohs();
      if (response && response.status === 200 && response.data) {
        let filteredMohs = response.data;
        if (idtenant && !idtenant.includes('vgs')) {
          filteredMohs = response.data.filter((moh) => idtenant.includes(moh.accountcode));
        }
        setMohs(filteredMohs);
      }
    } catch (error) {
      console.error("Erro ao buscar músicas de espera:", error);
    }
  };

  const validateUserLogged = useCallback(async () => {
    const dataUser = accessLocalStorage.getUserLocalStorage();
    const { user: { role, idtenant } } = dataUser;
    if (!dataUser) return history.push('/');
    if (dataUser && role !== 'root') return history.push('/home');
    let fetchTenants = await readAllTenant();
    if (!fetchTenants) return;
    if (!idtenant.includes('vgs')) fetchTenants = fetchTenants.filter((tenant) => tenant.short_name === idtenant);
    setTenants(fetchTenants);
    await fetchMohs(idtenant);
    return setLoading(false);
  }, [history]);

  const changeScreen = (check, name) => {
    changeBorderImputToRedOrNormal(check, name);
    changeVisibityMessages(check, `${name}-invalid-data`);
  };

  const handleChangeDataAnalyze = (name, value) => {
    const { checkNumber, checkPassword, isTripleChar } = valuesAnalyze;

    if(name === 'first' || name === 'qtt' || name === 'state' || name === 'maxContacts') {
      let checkValueIsNumber = checkNumber(value);
      if(name === 'qtt' && value > 1000) checkValueIsNumber = false;
      if(name === 'maxContacts' && (value < 1 || value > 10)) checkValueIsNumber = false;
      changeScreen(checkValueIsNumber, name);

      return checkValueIsNumber;
    };

    if(name === 'password') {
      const passwordIsValid = checkPassword(value);
      changeScreen(passwordIsValid, name);
      return passwordIsValid;
    }

    if(name === 'callGroup'|| name === 'pickupGroup') {
      const checkValueIsCharacters = isTripleChar(value);
      changeScreen(checkValueIsCharacters, name);
      return checkValueIsCharacters;
    }
  };

  const handleChangeCodec = (name, value) => {
    let prevSetValueCodec = values[name];

    if (!values.hasOwnProperty('codec')) prevSetValueCodec = [];
    prevSetValueCodec = prevSetValueCodec.includes(value) ? prevSetValueCodec.filter((codec) => codec !== value) : [...prevSetValueCodec, value];
    prevSetValueCodec.toString();

    setValues((prevState) => prevState, values[name] = prevSetValueCodec);
  };

  const handleChangeValues = (item) => {
    const { name, value } = item;

    const itemStatus = handleChangeDataAnalyze(name, value);
    if (name === 'codec') handleChangeCodec(name, value);
    setValidate((prevState) => prevState, validate[name] = itemStatus === undefined  ? true : itemStatus);
    if (name !== 'codec') setValues((prevState) => prevState, values[name] = value )
    // Removido 'type' (sempre HYBRID) e 'transport' (agora opcional), então são 12 campos esperados.
    if(Object.keys(validate).length >= 12) Object.values(validate).includes(false) ? setDisable(true) : setDisable(false);
    return;
  };

  const sendDataEndpointsGenerate = async () => {
    // Sempre híbrido: backend cria SIP + WebRTC numa transação.
    values.type = 'HYBRID';
    const filteredProperties = majoritaryItemsEndpoints.filter((item) => !values.hasOwnProperty(item));

    if(filteredProperties.length > 0) {
      toggleIsHidden('#alert-create-endpoints');

      filteredProperties.forEach((prop) => {
        changeVisibityMessages(false, prop);
        changeBorderImputToRedOrNormal(false, prop);
      });
      return;
    };
    values.context = `${values.context}-${values.tenant}`;
    const fetchEndpoints = await exportCreateEndpoints(values);
    toggleIsChangeFormElements('alert-create-endpoints', 'is-hidden');
    const result = Object.keys(fetchEndpoints).length > 0 ? true : false;
    if(result) {
      setLoading(false);
      changeVisibityMessages(true, 'create-form');
      changeVisibityMessages(true, 'button-send-form');
      changeVisibityMessages(false, 'success-create-endpoints');
      setTimeout(() => {
        return history.push('/config/ramal/lista');
      }, 3000);
    };
    return;
  };

  useEffect(() => {
    validateUserLogged();
  }, [validateUserLogged]);

  return (
    <div>
      {
        loading ?
          <Loading />
        :
        <div className="endpoints-form-container">
          <div className="endpoints-form-header">
            <div className="endpoints-form-title-wrapper">
              <svg className="endpoints-form-icon" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
              </svg>
              <div>
                <h1 className="endpoints-form-title">Adicionar Ramais</h1>
                <p className="endpoints-form-subtitle">Crie novos ramais para o sistema</p>
              </div>
            </div>
          </div>

          <div className="alerts-section">
            <div id="alert-create-endpoints" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Atenção!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#alert-create-endpoints')}>×</button>
              </div>
              <div className="alert-body">
                Não é possível gerar ramal com os campos abaixo não preenchidos.
                <br />
                Por favor, verifique os dados e clique novamente no botão <strong>Criar Ramais</strong> 
              </div>
            </div>

            <div id="error-create-endpoints" className="alert-message alert-danger is-hidden">
              <div className="alert-header">
                <span>Erro!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#error-create-endpoints')}>×</button>
              </div>
              <div className="alert-body">
                Não foi possível criar os ramais!
                <br />
                Verifique se os ramais já existem!
              </div>
            </div>

            <div id="success-create-endpoints" className="alert-message alert-success is-hidden">
              <div className="alert-header">
                <span>Sucesso!</span>
                <button className="alert-close" aria-label="delete" onClick={() => toggleIsHidden('#success-create-endpoints')}>×</button>
              </div>
              <div className="alert-body">
                Ramais criados com <strong>sucesso</strong>!
                <br />Login SIP: <code>&lt;ramal&gt;</code>
                <br />Login WebRTC: <code>&lt;ramal&gt;-web</code>
                <br />Senha: mesma para ambos.
              </div>
            </div>
          </div>
          <form name="create-form" id="create-form" onSubmit={(e) => e.preventDefault()}>
            <div className="form-card">
              <div className="hybrid-info-box" style={{
                padding: '12px 16px',
                backgroundColor: '#e3f2fd',
                border: '1px solid #90caf9',
                borderRadius: '6px',
                marginBottom: '16px',
                fontSize: '0.9rem',
                lineHeight: '1.5',
              }}>
                <strong>Cada ramal é criado como SIP (telefone/softphone) e WebRTC (navegador) simultaneamente.</strong>
                <br />
                Login SIP: <code>&lt;ramal&gt;</code> &nbsp;|&nbsp;
                Login WebRTC: <code>&lt;ramal&gt;-web</code> &nbsp;|&nbsp;
                Senha: mesma para ambos.
              </div>

              <div className="form-section-title">Informações Básicas</div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Ramal Inicial</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="first" 
                      type="text" 
                      onChange={(e) => handleChangeValues(e.target)} 
                      placeholder="Apenas números" 
                    />
                    <span name="first-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Quantidade</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="qtt" 
                      type="text" 
                      onChange={(e) => handleChangeValues(e.target)} 
                      placeholder="Máximo 1000" 
                    />
                    <span name="qtt-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Senha</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="password" 
                      type="text" 
                      onBlur={(e) => handleChangeValues(e.target)} 
                      placeholder="Mínimo 6 caracteres (@!#$&)" 
                    />
                    <span name="password-invalid-data" className='form-error is-hidden'>Verifique o tamanho e se existem caracteres inválidos!</span>
                  </div>
                </div>
              </div>

              <div className="form-section-title">Configurações de Protocolo</div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Protocolo (opcional)</label>
                  <div className="form-control">
                    <select
                      className="form-select"
                      name="transport"
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">— (automático)</option>
                      <option value="udp_transport">UDP</option>
                      <option value="tcp_transport">TCP</option>
                    </select>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">DTMF</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="dtmf" 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="rfc2833">RFC-2833</option>
                      <option value="info">INFO</option>
                      <option value="shortinfo">SHORTINFO</option>
                      <option value="inband">IN-BAND</option>
                      <option value="auto">AUTO</option>
                    </select>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Previlégios</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="context" 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="interno">Chamadas Internas</option>
                      <option value="local-fixo">Chamadas Local Fixo</option>
                      <option value="local-celular">Chamadas Local Celular</option>
                      <option value="ddd-fixo">Chamadas DDD Fixo</option>
                      <option value="ddd-celular">Chamadas DDD Celular</option>
                      <option value="internacional">Internacional</option>
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-section-title">Codecs e Configurações Avançadas</div>
              <div className="form-row">
                <div className="form-field-full">
                  <div className="codec-group">
                    <div className="codec-group-title">Codecs</div>
                    <div className="codec-options">
                      <div className="codec-option">
                        <label>ALAW</label>
                        <input 
                          className='codec-checkbox' 
                          name="codec" 
                          type="checkbox" 
                          value="alaw" 
                          onChange={(e) => handleChangeValues(e.target)}
                        />
                      </div>
                      <div className="codec-option">
                        <label>ULAW</label>
                        <input 
                          className='codec-checkbox' 
                          name="codec" 
                          type="checkbox" 
                          value="ulaw" 
                          onChange={(e) => handleChangeValues(e.target)}
                        />
                      </div>
                      <div className="codec-option">
                        <label>G.729</label>
                        <input 
                          className='codec-checkbox' 
                          name="codec" 
                          type="checkbox" 
                          value="g729" 
                          onChange={(e) => handleChangeValues(e.target)}
                        />
                      </div>
                      <div className="codec-option">
                        <label>H.264</label>
                        <input 
                          className='codec-checkbox' 
                          name="codec" 
                          type="checkbox" 
                          value="h264" 
                          onChange={(e) => handleChangeValues(e.target)}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">NAT</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="nat" 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="no">Não</option>
                      <option value="yes">Sim</option>
                    </select>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Chamadas Simultâneas</label>
                  <div className="form-control">
                    <input
                      className="form-input"
                      name="state"
                      type="text"
                      onChange={(e) => handleChangeValues(e.target)}
                      placeholder="Apenas números"
                    />
                    <span name="state-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Max. Dispositivos</label>
                  <div className="form-control">
                    <input
                      className="form-input"
                      name="maxContacts"
                      type="text"
                      onChange={(e) => handleChangeValues(e.target)}
                      placeholder="1 a 10"
                    />
                    <span name="maxContacts-invalid-data" className='form-error is-hidden'>Valor deve ser entre 1 e 10!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Cliente</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="tenant" 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      {tenants.map((tenant) => <option key={`${tenant.short_name}`} value={tenant.short_name}>{tenant.name}</option>)}
                    </select>
                  </div>
                </div>
              </div>

              <div className="form-section-title">Grupos</div>
              <div className="form-row">
                <div className="form-field">
                  <label className="form-label">Grupo de Chamada</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="callGroup" 
                      type="text" 
                      onChange={(e) => handleChangeValues(e.target)} 
                      placeholder="Apenas texto (-_,)" 
                    />
                    <span name="callGroup-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Grupo de Captura</label>
                  <div className="form-control">
                    <input 
                      className="form-input" 
                      name="pickupGroup" 
                      type="text" 
                      onChange={(e) => handleChangeValues(e.target)} 
                      placeholder="Apenas texto (-_,)" 
                    />
                    <span name="pickupGroup-invalid-data" className='form-error is-hidden'>Caracteres inválidos!</span>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Linguagem</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="language" 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Selecione</option>
                      <option value="en">Inglês</option>
                      <option value="pt_BR">Português</option>
                    </select>
                  </div>
                </div>

                <div className="form-field">
                  <label className="form-label">Música de Espera</label>
                  <div className="form-control">
                    <select 
                      className="form-select" 
                      name="moh" 
                      onChange={(e) => handleChangeValues(e.target)}
                    >
                      <option value="">Padrão (tenant)</option>
                      {mohs.filter((moh) => moh.name !== 'default').map((moh) => (
                        <option key={moh.name} value={moh.name}>
                          {moh.name}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
              </div>

              <div id="button-send-form" className="form-actions">
                <Link to="/config/ramal/lista" className="btn-cancel">
                  <FontAwesomeIcon icon={faTimes} />
                  Cancelar
                </Link>
                <button 
                  className="btn-submit" 
                  type="submit" 
                  disabled={disable} 
                  onClick={() => sendDataEndpointsGenerate()}
                >
                  <FontAwesomeIcon icon={faSave} />
                  Criar Ramais
                </button>
              </div>
            </div>
          </form>
        </div>
      }
    </div>
  );
}

export default EndpointsCreate;
